import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, concat, Observable, of } from 'rxjs';
import { ServiceHelper } from '../config';
import { MyAuctionLotModel } from '../models';
import { AppConfig } from '../config';
import { map, switchMap, tap } from 'rxjs/operators';
import { AuctionLotService, StateService } from '.';
import * as moment from 'moment';

@Injectable()
export class MyAuctionLotService {

    constructor(public http: HttpClient, public serviceHelper: ServiceHelper, private stateService: StateService, private appConfig: AppConfig) {
        var me = this;
    }

    auctionId: number;

    savedPrices: any[] = [];

    myAuctionLots: MyAuctionLotModel[] = [];
    myAuctionLotsTrigger$ = new BehaviorSubject<boolean>(true);
    myAuctionLots$ = this.myAuctionLotsTrigger$.pipe(
        switchMap(_ =>
            concat(
                of({ type: 'start', value: null }),
                this.MyAuctionLots(this.auctionId).pipe(map(value => ({ type: 'finish', value })))
            )),
        tap(res => {
            if (res.type === 'finish') {
                var results = res.type === 'finish' ? res.value : [];
                // console.log('myAuctionLots$.after', results);

                this.myAuctionLots = results.map(x => {
                    var data = Object.assign(new MyAuctionLotModel(), x);
                    if (data?.BidDate) data.BidDate = moment.tz(data.BidDate, 'Australia/Melbourne').toDate();
                    if (data?.AuctionLot?.CurrentBidDateTime) data.AuctionLot.CurrentBidDateTime = moment.tz(data.AuctionLot.CurrentBidDateTime, 'Australia/Melbourne').toDate();
                    return data;
                });
            }
        }),
    );

    get currentWinningBids(): number {
        return this.myAuctionLots.filter(x => x.IsWinning === true).reduce((sum, current) => sum + current.TempBidAmount, 0);
    }
    get currentMaximum(): number {
        return this.myAuctionLots.reduce((sum, current) => sum + current.TempAutoBidAmount, 0);
    }
    get currentBpa(): number {
        return this.myAuctionLots.filter(x => x.IsWinning === true).reduce((sum, current) => sum + current.TempBuyerPremiumAmount, 0);
    }

    UpdateItem(myAuctionLot: MyAuctionLotModel) {
        let me = this;
        me.stateService.loginKeepAlive();
        if (myAuctionLot) {
            let matchFound = false;
            for (let i = 0; i < me.myAuctionLots.length; i++) {
                let current = me.myAuctionLots[i];
                if (current.Id == myAuctionLot.Id) {
                    matchFound = true;
                    // console.log('myAuctionLot: matching myauctionlot, updating details', current, myAuctionLot);

                    if (current.BidDate < myAuctionLot.BidDate) {
                        current.BidDate = myAuctionLot.BidDate;
                        current.BidAmount = myAuctionLot.BidAmount;
                        current.IsWinning = myAuctionLot.IsWinning;
                        current.TempBidAmount = myAuctionLot.TempBidAmount;
                        current.TempAutoBidAmount = myAuctionLot.TempAutoBidAmount;
                        current.TempBuyerPremiumAmount = myAuctionLot.TempBuyerPremiumAmount;
                        current.MinimumNextBid = myAuctionLot.MinimumNextBid;
                        current.AutoBidAmount = myAuctionLot.AutoBidAmount;
                        current.WatchingOnly = myAuctionLot.WatchingOnly;
                    } else {
                        console.warn('Attempted update is older than current data', myAuctionLot.Id, current.BidDate, myAuctionLot.BidDate);
                    }
                }
            }
            if (!matchFound) {
                console.warn('No match found', myAuctionLot);
            }
        }
    }

    UpdateList() {
        let me = this;
        // console.log('UpdateList', me.auctionId);
        me.stateService.loginKeepAlive();
        if (me.myAuctionLotsTrigger$)
            me.myAuctionLotsTrigger$.next(true);
        else
            me.myAuctionLotsTrigger$ = new BehaviorSubject<boolean>(true);
    }

    MyAuctionLots(auctionId: number): Observable<MyAuctionLotModel[]> {
        let me = this;
        var headers = this.serviceHelper.GetHeaders();

        // console.log('MyAuctionLots', auctionId);
        if (!auctionId)
            return of([]);

        return this.http.post<MyAuctionLotModel[]>(this.appConfig.getConfig('apiUrl') + '/my-auction-lots/' + (auctionId ? auctionId : ''), {}, { withCredentials: true, headers: headers });
    }

    AddToWatchList(auctionLotIds: number[], connectionId: string): Observable<any> {
        let me = this;
        var headers = this.serviceHelper.GetHeaders();

        // console.log('AddToWatchList', auctionLotIds);

        return this.http.post<void>(this.appConfig.getConfig('apiUrl') + '/my-auction-lots/watch', { auctionLotIds, connectionId }, { withCredentials: true, headers: headers });
    }

    RemoveFromWatchList(auctionLotIds: number[], connectionId: string): Observable<any> {
        let me = this;
        var headers = this.serviceHelper.GetHeaders();

        // console.log('RemoveFromWatchList', auctionLotIds);

        return this.http.post<void>(this.appConfig.getConfig('apiUrl') + '/my-auction-lots/unwatch', { auctionLotIds, connectionId }, { withCredentials: true, headers: headers });
    }

    Hide(auctionLotIds: number[]): Observable<any> {
        let me = this;
        var headers = this.serviceHelper.GetHeaders();

        // console.log('Hide', auctionLotIds);

        return this.http.post<void>(this.appConfig.getConfig('apiUrl') + '/my-auction-lots/hide', auctionLotIds, { withCredentials: true, headers: headers });
    }

    Unhide(auctionLotIds: number[]): Observable<any> {
        let me = this;
        var headers = this.serviceHelper.GetHeaders();

        // console.log('Unhide', auctionLotIds);

        return this.http.post<void>(this.appConfig.getConfig('apiUrl') + '/my-auction-lots/unhide', auctionLotIds, { withCredentials: true, headers: headers });
    }

    SetSavedBid(auctionLotId: number, bidAmount?: number): Observable<any> {
        let me = this;
        var headers = this.serviceHelper.GetHeaders();

        // console.log('SetSavedBid', auctionLotId, bidAmount);

        return this.http.post<void>(this.appConfig.getConfig('apiUrl') + '/my-auction-lots/save-bid', { auctionLotId, bidAmount }, { withCredentials: true, headers: headers });
    }
}